import { type OktaAuthOptions } from '@okta/okta-auth-js'

export const scopeDomainPrefix = 'lmi-fustonline-api'

const deploymentEnvironmentByMode = {
  development: 'development',
  test: 'test',
  sandbox: 'sandbox',
  staging: 'staging',
  live: 'live',
  production: 'live',
} as const

export type DeploymentEnvironment =
  (typeof deploymentEnvironmentByMode)[keyof typeof deploymentEnvironmentByMode]

const deploymentEnvironment =
  deploymentEnvironmentByMode[
    import.meta.env.MODE as keyof typeof deploymentEnvironmentByMode
  ] ?? 'development'

const sentryEnvironmentByDeployment: Record<DeploymentEnvironment, string> = {
  development: 'development',
  test: 'test',
  sandbox: 'test',
  staging: 'staging',
  live: 'live',
}

const oktaScopes = [
  'openid',
  'profile',
  'email',
  'offline_access',
  `${scopeDomainPrefix}-${import.meta.env.VITE_OKTA_ENV}`,
]

export type AppConfig = {
  api: string
  deploymentEnvironment: DeploymentEnvironment
  sentryEnvironment: string
  oidc: OktaAuthOptions
}

export const Config: AppConfig = {
  api: import.meta.env.VITE_API_HOST_VALUE,
  deploymentEnvironment,
  sentryEnvironment: sentryEnvironmentByDeployment[deploymentEnvironment],
  oidc: {
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
    issuer: import.meta.env.VITE_OKTA_ISSUER,
    redirectUri: `${globalThis.location.origin}/callback`,
    scopes: oktaScopes,
    devMode: import.meta.env.DEV,
    pkce: import.meta.env.TEST,
  },
}
